import { Drawer } from '@mui/material'
import { useLocale } from 'next-intl'
import { FC } from 'react'

interface FlightDetailsWrapperProps {
    open: boolean
    onClose: () => void
    children: React.ReactNode
}

const FlightDetailsWrapperDesktop: FC<FlightDetailsWrapperProps> = ({ open, onClose, children }) => {
    const local = useLocale()
    return (
        <Drawer
            anchor="right"
            open={open}
            onClose={onClose}
            slotProps={{
                paper: {
                    sx: {
                        width: { md: '500px', lg: '620px' }
                    }
                }
            }}
            dir={local === 'ar' ? 'rtl' : 'ltr'}
        >
            {open && children}
        </Drawer>
    )
}

export default FlightDetailsWrapperDesktop
